import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";

import {
  selectActiveDepartments,
  selectAllDepartments,
  selectDepartmentById,
  selectDepartmentsWithoutRequiredAgent,
} from "./departmentsSlice";
import { useAppSelector } from "../../common/hooks/useStore";
import { PropsWithClassName } from "../../common/types/PropsWithClassName";
import NoResultsFound from "../../common/components/noResultsFound/NoResultsFound";

interface DepartmentsDropdownProps extends PropsWithClassName {
  optionsType?: "all" | "active" | "withoutRequiredAgent";
  value?: string;
  onChange: (departmentId: string) => void;
  disabled?: boolean;
}

const selectorMap = {
  all: selectAllDepartments,
  active: selectActiveDepartments,
  withoutRequiredAgent: selectDepartmentsWithoutRequiredAgent,
};

export default function DepartmentsDropdown({ className, optionsType = "active", value, onChange, disabled }: DepartmentsDropdownProps) {
  const departments = useSelector(selectorMap[optionsType]);
  const selectedDepartment = useAppSelector((state) => selectDepartmentById(state, value));

  let options = departments;
  const missingSelectedDepartment = !departments.some((department) => department.id === selectedDepartment?.id);
  if (selectedDepartment && missingSelectedDepartment) {
    options = [selectedDepartment, ...departments];
  }

  useEffect(() => {
    if (!value && departments[0]) {
      setTimeout(() => {
        // This is a workaround to avoid the dropdown being empty when the component is mounted
        // Ideally should be removed and handled by the parent component
        onChange(departments[0].id);
      });
    }
  }, [departments]);

  return (
    <Dropdown
      className={`${className}`}
      placeholder="Selecteaza departament"
      optionLabel="name"
      options={options}
      value={selectedDepartment}
      emptyMessage={<NoResultsFound />}
      disabled={disabled}
      onChange={(e) => onChange(e.value.id)}
    />
  );
}
